import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import {client} from './app/apollo.config'
import './index.css';

import {
  ApolloProvider
} from "@apollo/client";
import App from './App';

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById('root')
);

reportWebVitals();
